import React from 'react';
import { Link } from "react-router-dom";
import UserResumes from '../components/UserResumes.jsx';
// import CEResume from '../components/CEResume.jsx';
import '../styles/Home.css'
import UserData from '../components/UserData.jsx';

const HomePage = () => {

    return (
        <div className='App'>
            <div className='home'>
                <div className='homeBlock' data-test="userData">
                    <UserData />
                </div>
                <div className='homeBlock'>
                    <Link className="btnSCV btnSCV-a btnSCV-long" data-test="create" to="/resumeCreator">create new resume</Link>
                    <UserResumes />
                    {/* < CEResume /> */}
                </div>
            </div>
        </div >
    );
}

export default HomePage;